import type React from 'react';
import { lazy, Suspense } from 'react';
import Fallback from './Fallback';

function iconLazy(
  loaderFn: () => Promise<{ default: React.ComponentType<React.SVGProps<SVGSVGElement>> }>,
) {
  const LazyComponent = lazy(loaderFn);

  function DynamicComponent(props: React.SVGProps<SVGSVGElement>) {
    return (
      <Suspense fallback={<Fallback {...props} />}>
        <LazyComponent {...props} />
      </Suspense>
    );
  }

  DynamicComponent.displayName = 'DynamicIcon';
  return DynamicComponent;
}

export default iconLazy;
